export function MinusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="3"
      viewBox="0 0 10 3"
      fill="none"
    >
      <path
        d="M9.95889 1.21634V2.15317C9.95889 2.57684 9.61557 2.92199 9.19007 2.92199H1.37771C0.952207 2.92381 0.608887 2.57867 0.608887 2.15499V1.21817C0.608887 0.794495 0.952207 0.449348 1.37771 0.449348H9.19007C9.61557 0.447522 9.95889 0.792669 9.95889 1.21634Z"
        fill="#363636"
      />
      <path
        d="M0.791016 2.15511V1.21828C0.791016 0.895049 1.05398 0.63208 1.37722 0.63208H9.18959C9.51282 0.63208 9.77579 0.895049 9.77579 1.21828V2.15511C9.77579 2.47834 9.51282 2.74131 9.18959 2.74131H1.37722C1.05398 2.74131 0.791016 2.47834 0.791016 2.15511Z"
        fill="#D9D7C5"
      />
    </svg>
  )
}
